const ONE_BILLION = 1000000000;
const ONE_MILLION = 1000000;
const ONE_THOUSAND = 1000;

const kformatter = (num: number) => {
  if (num >= ONE_BILLION) {
    return format(num, ONE_BILLION, 'G');
  }
  if (num >= ONE_MILLION) {
    return format(num, ONE_MILLION, 'M');
  }
  if (num >= ONE_THOUSAND) {
    return format(num, ONE_THOUSAND, 'K');
  }
  return num;
};

const format = (num: number, decimal: number, suffix: 'K' | 'M' | 'G') => {
  const roundedNumber = (num / decimal).toFixed(1).replace(/\.0$/, '');
  return `${roundedNumber}${suffix}`;
};

export default kformatter;
